import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=b4fdc810&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4fdc810')) {
      api.createRecord('b4fdc810', component.options)
    } else {
      api.reload('b4fdc810', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=b4fdc810&", function () {
      api.rerender('b4fdc810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8VomI2R61grYR/JS/videoIframe.vue"
export default component.exports